import React from 'react';
import { Card, Form, Input, Button, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';

const { Title, Text } = Typography;

const SuperadminLogin = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleFinish = async (_values) => {
    // TODO: wire to superadmin auth when available
    navigate('/superadmin', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-4">
      <Card className="w-full max-w-md shadow-md">
        <div className="text-center mb-6">
          <Title level={3} className="!mb-1 dark:!text-slate-100">Superadmin Sign in</Title>
          <Text className="dark:!text-slate-400">Manage companies and approvals</Text>
        </div>
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Form.Item name="email" label="Email" rules={[{ required: true }, { type: 'email' }]}>
            <Input prefix={<MailOutlined />} placeholder="superadmin@example.com" autoComplete="email" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="••••••••" autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>Sign in</Button>
        </Form>
        <div className="mt-4 text-center">
          <Text className="dark:!text-slate-400"><Link to="/login">Back to tenant login</Link></Text>
        </div>
      </Card>
    </div>
  );
};

export default SuperadminLogin;
